// extracted by mini-css-extract-plugin
export var searchHeader = "_4y-0";
export var searchHeaderDark = "_4y-1";